// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DigiLockerSuccess_successContainer__mXdun {
    display: flex; /* Use flexbox for centering */
    flex-direction: column; /* Stack items vertically */
    justify-content: center; /* Center vertically */
    align-items: center; /* Center horizontally */
    height: 100vh; /* Full viewport height */
    padding: 20px;
    background-color: #ffffff; /* White background */
    border: 2px solid #4caf50; /* Green border */
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.DigiLockerSuccess_successImage__9OJl9 {
    width: 100px; /* Adjust size as needed */
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/organism/DigiLockerSuccess.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa,EAAE,8BAA8B;IAC7C,sBAAsB,EAAE,2BAA2B;IACnD,uBAAuB,EAAE,sBAAsB;IAC/C,mBAAmB,EAAE,wBAAwB;IAC7C,aAAa,EAAE,yBAAyB;IACxC,aAAa;IACb,yBAAyB,EAAE,qBAAqB;IAChD,yBAAyB,EAAE,iBAAiB;IAC5C,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,mBAAmB;AACvB","sourcesContent":[".successContainer {\n    display: flex; /* Use flexbox for centering */\n    flex-direction: column; /* Stack items vertically */\n    justify-content: center; /* Center vertically */\n    align-items: center; /* Center horizontally */\n    height: 100vh; /* Full viewport height */\n    padding: 20px;\n    background-color: #ffffff; /* White background */\n    border: 2px solid #4caf50; /* Green border */\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.successImage {\n    width: 100px; /* Adjust size as needed */\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successContainer": `DigiLockerSuccess_successContainer__mXdun`,
	"successImage": `DigiLockerSuccess_successImage__9OJl9`
};
export default ___CSS_LOADER_EXPORT___;
